export const POPUPS_IDS = {
  CONFIRMATION: 1,
};
